import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-W261PBXY5W");
};

export const logPageView = (path : any) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
